import { motion } from "framer-motion";
import {
  Zap, LayoutGrid, Cloud, BookOpen, Sparkles, Microscope, Code2, Clapperboard, Mail, FileText, Table2, HardDrive,
} from "lucide-react";
import { SectionHeader } from "./SectionHeader";

const benefits = [
  { icon: Zap, title: "AI Tercepat Google", color: "text-blue-600 bg-blue-50" },
  { icon: LayoutGrid, title: "Terintegrasi Workspace", color: "text-emerald-600 bg-emerald-50" },
  { icon: Cloud, title: "5TB Cloud Storage", color: "text-sky-600 bg-sky-50" },
  { icon: BookOpen, title: "NotebookLM Premium", color: "text-amber-600 bg-amber-50" },
  { icon: Sparkles, title: "Gemini 3.1 Pro", color: "text-indigo-600 bg-indigo-50" },
  { icon: Microscope, title: "Deep Research", color: "text-rose-600 bg-rose-50" },
  { icon: Code2, title: "Coding Assistant", color: "text-violet-600 bg-violet-50" },
  { icon: Clapperboard, title: "Flow AI Video", color: "text-cyan-600 bg-cyan-50" },
  { icon: Mail, title: "Gmail Premium", color: "text-red-600 bg-red-50" },
  { icon: FileText, title: "Google Docs AI", color: "text-blue-600 bg-blue-50" },
  { icon: Table2, title: "Google Sheets AI", color: "text-green-600 bg-green-50" },
  { icon: HardDrive, title: "Google Drive Premium", color: "text-yellow-600 bg-yellow-50" },
];

export const Benefits = () => (
  <section className="py-20 md:py-28 bg-slate-50" id="kenapa">
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <SectionHeader
        title="Kenapa Gemini Pro?"
        sub="Satu paket, seluruh ekosistem AI premium Google. Semua ini aktif otomatis di akun Anda selama 18 bulan penuh."
      />
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
        {benefits.map(({ icon: Icon, title, color }, i) => (
          <motion.div
            key={title}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.5, delay: (i % 4) * 0.08, ease: [0.22, 1, 0.36, 1] }}
            className="group rounded-3xl bg-white border border-slate-200/80 p-5 md:p-6 shadow-[0_4px_20px_rgba(0,0,0,0.03)] hover:shadow-[0_16px_40px_rgba(37,99,235,0.12)] hover:-translate-y-1.5 transition-[transform,box-shadow] duration-300"
            data-testid={`benefit-card-${i}`}
          >
            <span className={`inline-flex w-11 h-11 rounded-2xl items-center justify-center ${color} group-hover:scale-110 transition-transform duration-300`}>
              <Icon className="w-5 h-5" strokeWidth={2.2} />
            </span>
            <p className="mt-4 font-heading font-bold text-slate-900 text-sm md:text-base leading-snug">{title}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
